import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { CertificateType } from "@/common/types/certificate";

export async function certificateList(
  account_id: string,
  owner_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/certificate/${owner_id}/list${queryString}`,
  );
}

export async function certificateGet(
  account_id: string,
  owner_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/certificate/${owner_id}/show/${queryString}`,
  );
}

export async function certificateCreate(account_id: string, owner_id: string) {
  return await clientAxios.post(
    `account/${account_id}/certificate/${owner_id}/create`,
    {},
  );
}

export async function certificatePatch(
  account_id: string,
  certificate_id: string,
  payload: Partial<CertificateType>,
) {
  return await clientAxios.patch(
    `account/${account_id}/certificate/${certificate_id}/patch`,
    {
      payload,
    },
  );
}

export async function certificateUpdate(
  account_id: string,
  certificate_id: string,
  file: string,
) {
  return await clientAxios.put(
    `account/${account_id}/certificate/${certificate_id}/update`,
    {
      file,
    },
  );
}

export async function certificateDelete(
  account_id: string,
  certificate_id: string,
) {
  return await clientAxios.del(
    `account/${account_id}/certificate/${certificate_id}/delete`,
  );
}
